<template>
  <div style="display: inline-block">
    <slot name="default"
          :isOnline="isOnline"
          :device="device"
          :employee="employee"
          :loading="loading"
          :allowLiveView="allowLiveView"
    ></slot>
  </div>
</template>

<script>


import AppDlg from "@/components/Shared/AppDlg.vue";
import AppList from "@/components/Shared/AppList/AppList.vue";
import {getSocket} from "@/core/realtimeSync";
import {mapGetters} from "vuex";

export default {
  components: {AppList, AppDlg},
  props: {
    deviceId: {
      type: String,
      required: true
    },
  },
  mounted() {
    this.checkOnline()
  },
  beforeDestroy() {
    this.stopped = true
    clearTimeout(this.checker)
  },
  data() {
    return {
      loading: true,
      isOnline: null,
      checker: null,
      stopped: false
    }
  },
  methods: {
    async checkOnline() {
      try {
        this.loading = true
        const res = await this.$newReq('GET', `devices/isOnline/${this.deviceId}`)
        this.isOnline = true
      } catch (e) {
        // Do Nothing
        this.isOnline = false
      } finally {
        this.loading = false
        if (!this.stopped) {
          this.checker = setTimeout(() => {
            this.checkOnline()
          }, 75000)
        }
      }
    },
  },
  computed: {
    ...mapGetters(['devicesRef', 'employeesRef', 'access']),
    
    allowLiveView() {
      return this.access?.screenshots && this.employee?.enableScreenshots && this.$store.state.liveViewEnabled
    },
    
    device() {
      return this.devicesRef[this.deviceId]
    },
    
    employee() {
      return this.employeesRef[this.device?.employeeId]
    },
  },
}
</script>

<style scoped>

</style>